// extracted by mini-css-extract-plugin
export default {"option-wrapper":"_0aqBDjubSeI0-myYu2F4CA==","delivery-channel-switch":"eFwjBBNCbq4pYPJgyTMYPA=="};